import { AbilityBuilder, createMongoAbility } from '@casl/ability'
import { PROJECT_ROLE } from "@helpers/ConstantHelper.js"

const ability = createMongoAbility([])
const cacheRoles = {}
export const useProjectPermission = () => {
  const { data: session } = useAuth()
  const user = session.value.user
  const userId = user?.id

  const setAbilities = project => {
    const abilities = project?.value?.abilities ?? project?.abilities
    const id = project?.value?.id ?? project?.id
    const projectRuleId = `project:${id}`
    const { can, rules } = new AbilityBuilder(createMongoAbility)

    Object.keys(abilities || {}).forEach(action => {
      if (abilities[action]) {
        can(action, projectRuleId)
      }
    })

    const currentRules = ability.rules.filter(item => item.subject !== projectRuleId)

    ability.update([...currentRules, ...rules])
  }

  const setAbilityCollections = projects => {
    const items = projects.value ?? projects ?? []

    items.forEach(item => setAbilities(item))
  }

  const can = (action, project) => {
    const id = project?.value?.id ?? project?.id
    const subject = `project:${id}`

    return ability.can(action, subject)
  }

  const isRole = (project, role) => {
    const projectId = project?.value?.id ?? project.id ?? null
    if (!projectId) {
      return false
    }

    const checkRole = cacheRoles?.[role]?.[projectId] ?? null
    if (checkRole) {
      return true
    }

    const staffs = project?.value?.staffs ?? project.staffs ?? []
    const staff = staffs.find(staff => staff.id === userId)
    if (staff?.type === role) {
      if (!cacheRoles?.[role]) {
        cacheRoles[role] = {}
      }
      cacheRoles[role][projectId] = true

      return true
    }

    return false
  }

  const isLeader = project => (isRole(project, PROJECT_ROLE.LEADER))
  const isStaff = project => (isRole(project, PROJECT_ROLE.STAFF))
  const isRiskLevel1 = project => (isRole(project, PROJECT_ROLE.RISK_LEVEL1))
  const isRiskLevel2 = project => (isRole(project, PROJECT_ROLE.RISK_LEVEL2))
  const isVetting = project => (isRole(project, PROJECT_ROLE.ASSESSMENT))

  const isOwnerWorkSession = (project, workSession) => {
    const session = workSession?.value ?? workSession
    const ownerWorkSessionId = session?.creator?.id
    if (!ownerWorkSessionId) {

      return isLeader(project)
    }

    return ownerWorkSessionId === userId
  }

  const isOwnerPrintPdf = printPdf => {
    const item = printPdf?.value ?? printPdf
    const ownerId = item?.creator_staff_id ?? item?.creator_staff?.id ?? item?.creator?.id

    if (!ownerId || ownerId === -1) {
      return false
    }

    return ownerId === userId
  }


  return {
    ability,
    setAbilities,
    can,
    isStaff,
    isLeader,
    isRiskLevel1,
    isRiskLevel2,
    isVetting,
    setAbilityCollections,
    isOwnerWorkSession,
    isOwnerPrintPdf,
  }
}
